// extracted by mini-css-extract-plugin
export var grid = "simpleForm-module--grid--3ZsE3";
export var images = "simpleForm-module--images--2jAZZ";
export var logos = "simpleForm-module--logos--1JTAW";
export var form = "simpleForm-module--form--30EYB";
export var adCheck = "simpleForm-module--ad-check--207MP";
export var copy = "simpleForm-module--copy--1c2jP";
export var headline = "simpleForm-module--headline--14yVv";